import * as React from "react";
import { Button } from "@/components/ui/button";
import { aboveBottomStrip } from "@/components/common/bottom-nav/nav-constants";
import { cn } from "@/lib/utils";

// Anchor formula owned by specs/conventions/safe-area-bottom.md. The FAB
// sits FAB_GAP_PX above whatever runs along the bottom of the shell: the
// phone's nav or the bulk action bar, or nothing from 768px, where the nav is
// a rail. The layout publishes that height, so the FAB cannot drift from it.
export const FAB_GAP_PX = 16;
/** The FAB's `h-12`. The install banner stands above `FAB_GAP_PX + FAB_HEIGHT_PX`. */
export const FAB_HEIGHT_PX = 48;
const FAB_BOTTOM = aboveBottomStrip(FAB_GAP_PX);

type FloatingActionButtonProps = Omit<
  React.ComponentProps<typeof Button>,
  "variant" | "size" | "asChild"
> & {
  /** Tailwind z-index class; defaults to `z-40`. Override to layer above other
   * fixed UI (e.g. the Records "Upload" FAB uses `z-50` because it sits in the
   * same stacking context as the bottom nav). */
  zIndexClassName?: string;
};

export function FloatingActionButton({
  className,
  zIndexClassName = "z-40",
  style,
  ...buttonProps
}: FloatingActionButtonProps) {
  return (
    <Button
      size="lg"
      className={cn(
        "fixed right-4 h-12 rounded-full shadow-lg",
        zIndexClassName,
        className,
      )}
      {...buttonProps}
      // Merged, not replaced: a caller may shift the FAB sideways (e.g. clear of
      // the Photos record panel) but the bottom anchor is always ours.
      style={{ ...style, bottom: FAB_BOTTOM }}
    />
  );
}
